<template>
    <div>
        <div class="payment-text card-label-text-left">
            <img src="../../assets/images/payment.png" alt="payment"> Payment
        </div>
        <div class="secured-encryption card-label-text-left">
            <img src="../../assets/images/lock-white.png" alt="lock"> Secured with 2048-bit encryption
        </div>
    </div>
</template>

<script>
export default {
    name: 'PaymentHeader'
};
</script>